// extracted by mini-css-extract-plugin
export default {"widgetContainer":"widgetContainer--Zz5Z3","microComboWrap":"microComboWrap--Zz5Z3","trustPilotWidget":"trustPilotWidget--Zz5Z3"};